import { SpecYearTransfer }      from 'Component/SpecYearTransfer/SpecYearTransfer';
import { CustomSearchBarDrawer } from 'Container/CustomSearchBarDrawer/CustomSearchBarDrawer';
import React                     from 'react';

export const SpecYear = (props) => (
  <CustomSearchBarDrawer { ...props }>
    {({ value, onChange }) => <SpecYearTransfer value={value} onChange={onChange} />}
  </CustomSearchBarDrawer>
);
